import Vue from 'vue'
import Vuex from 'vuex'
import { showFooter, hideFooter, showNavbar, hideNavbar, getGoodslistMutation } from './type.js'
import { Message } from 'element-ui'
import axios from 'axios'
Vue.use(Vuex) // 注册vuex
const store = new Vuex.Store({
  state: {
    isFooterShow: true,
    isNavbarShow: true,
    isShowLoading: false,
    brandsId: false,
    goodslists: {},
    code: '1',
    count: '',
    value: '',
    isshowPdf: false
  },

  getters: {
    // filterMovie (state) {
    //   return state.movieList.slice(0, 5)
    // }
  },

  mutations: {
    [showFooter] (state) {
      state.isFooterShow = true
    },
    [hideFooter] (state) {
      state.isFooterShow = false
    },
    [hideNavbar] (state) {
      state.isNavbarShow = false
    },
    [showNavbar] (state) {
      state.isNavbarShow = true
    },
    [getGoodslistMutation] (state, data) {
      state.goodslists = data
    },
    handleShowLoading (state, data) {
      state.isShowLoading = data
    },
    handleHideLoading (state, data) {
      state.isShowLoading = data
    }

  },
  actions: {
    getGoodslistAction (store, data) {
      // 异步请求   ,brandId:sessionStorage.getItem('brandsId')
      // console.log(data.pageNumber)
      store.commit('handleShowLoading', true)
      if (data.pageNumber == undefined) {
        data.pageNumber = 1
      }
      axios({
        url: `https://www.awesomewholesale.com.au/api/v1/wholesale/homepage/goods?page=${data.pageNumber}&limit=10`,
        params: { goodsType: data.typeId, brandId: data.goodsBrands, goodsName: data.goodsName }
      }).then(res => {
        if (res.data.code == 200) {
          // console.log(res.data)
          store.commit('handleHideLoading', false)
          store.commit('getgoodslist', res.data.result) // mutation 名字 传过去的参数值
        } else {
          store.commit('handleHideLoading', false)
          Message.error({ message: res.data.msg })
        }
      })
    }
  },
  modules: {
  }
})

export default store
